module.exports = __webpack_public_path__ + "fonts/dFa6ZfeM_74wlPZtksIFajo6_V6LVlA.woff2";